// src/common/MonthIntervalDropdown.tsx
import React, { useEffect } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";

interface Props {
  title: string;
  onSelect: (value: number | string, label: string) => void;
  size?: "sm" | "lg";
  variant?: string;
  stopPropagation?: boolean;
  show?: boolean; // controlled visibility
  onToggle?: (isOpen: boolean) => void; // toggle handler
}

const intervals = [
  { label: "This Month", value: 1 },
  { label: "3 Month", value: 3 },
  { label: "6 Month", value: 6 },
  { label: "9 Month", value: 9 },
  { label: "12 Month", value: 12 },
];

const MonthIntervalDropdown: React.FC<Props> = ({
  title,
  onSelect,
  size = "sm",
  variant = "outline-secondary",
  stopPropagation = false,
  show,
  onToggle,
}) => {
  useEffect(() => {
    const handleScroll = () => {
      if (show) {
        onToggle?.(false);
      }
    };

    window.addEventListener("scroll", handleScroll, true);

    return () => {
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, [show, onToggle]);
  return (
    <DropdownButton
      size={size}
      variant={variant}
      title={
        <span className="d-flex align-items-center">
          {title}{" "}
          <span className="material-symbols-outlined pageinfo">page_info</span>
        </span>
      }
      onClick={stopPropagation ? (e) => e.stopPropagation() : undefined}
      show={show} // 🔑 controlled
      onToggle={onToggle} // 🔑 controlled
    >
      {intervals.map((item) => (
        <Dropdown.Item
          key={item.value}
          onClick={() => onSelect(item.value, item.label)}
        >
          {item.label}
        </Dropdown.Item>
      ))}
    </DropdownButton>
  );
};

export default MonthIntervalDropdown;
